import React from "react";
import {
  Row,
  Col,
  Space,
  message,
  Button,
  Modal,
  Image,
  Drawer,
  Tooltip,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";

import ListTable from "./ListTable";

import withRouter from "../withRouter";

import { CloseOutlined } from "@ant-design/icons";
import CompanyAutocomplete from "./CompanyAutocomplete";
import DiscountStore from "../store/DiscountStore";
import DiscountAdd from "./DiscountAdd";
import { Link } from "react-router-dom";
import CompanyStore from "../store/CompanyStore";
import editIcon from "../assets/images/NewDesign/pencil-square.svg";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
class DiscountList extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.discountStore = new DiscountStore(this);
    this.companyStore = new CompanyStore(this);

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      loadData: 1,
      companyId: "",
      comp_value: "",
      listDataUpdate: false,
      openDiscountForm: false,

      openDeleteModal: false,
      deleteData: {},
    };

    this.columns = [
      {
        title: context.translate("_COMAPNY_NAME_"),
        dataIndex: "name",
        width: 20,
        ellipsis: {
          showTitle: true,
        },
        render: (val, record) => {
          return (
            <Link
              style={{ color: "#2563EB", textDecoration: "none" }}
              onClick={(e) => {
                e.preventDefault();
                this.props.canUpdate("discountList") && this.onEdit(record);
              }}
            >
              {val}
            </Link>
          );
        },
      },
      {
        title: context.translate("_VEHICLE_TYPE_"),
        dataIndex: "vehicleType",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_DISCOUNT_NAME_"),
        dataIndex: "discountName",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_DISCOUNT_TYPE_"),
        dataIndex: "discountType",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
        render: (value) => {
          if (value == 1) {
            return <>%</>;
          } else if (value == 2) {
            return <>Flat Amount</>;
          }
        },
      },
      {
        title: context.translate("_DISCOUNT_"),
        dataIndex: "discountAmount",
        width: 20,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_VALID_FROM_"),
        dataIndex: "validFrom",
        width: 20,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_VALID_TO_"),
        dataIndex: "validTo",
        width: 20,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_ACTION_"),
        dataIndex: "action",
        width: 10,
        ellipsis: {
          showTitle: true,
        },
        render: (_, record) => {
          return (
            <>
              <Space>
                {this.props.canUpdate("discountList") && (
                  <Tooltip
                    title={this.context.translate("_EDIT_RECORD_")}
                    placement="bottom"
                  >
                    <Image
                      style={{
                        height: "19px",
                        width: "15px",
                        borderRadius: "0px",
                        cursor: "pointer",
                      }}
                      src={editIcon}
                      onClick={async (e) => {
                        e.preventDefault();
                        await this.onEdit(record);
                      }}
                    ></Image>
                  </Tooltip>
                )}
                {this.props.canDelete("discountList") && (
                  <Tooltip
                    title={this.context.translate("_DELETE_RECORD_")}
                    placement="bottom"
                  >
                    <Image
                      src={require("../assets/images/NewDesign/Delete.png")}
                      style={{ cursor: "pointer", width: "15px" }}
                      onClick={() =>
                        this.setState({
                          openDeleteModal: true,
                          deleteData: record,
                        })
                      }
                    ></Image>
                  </Tooltip>
                )}
              </Space>
            </>
          );
        },
      },
    ];
  }
  async componentDidMount() {
    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      console.log(this.props.getUserData().userCompanyId);
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });

      await this.handleSearch();
    }
    this.setState({ pageSize: 50 });
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevState.listDataUpdate !== this.state.listDataUpdate) {
      let setdiscountData = this.context.viewStateStore.discountObject;

      setdiscountData =
        typeof setdiscountData === "number"
          ? setdiscountData
          : setdiscountData.companyId;

      if (setdiscountData !== "") {
        await this.discountStore.loadData({
          companyId: setdiscountData,
          offset: (this.state.currentPage - 1) * this.state.pageSize,
          limit: this.state.pageSize,
          page: this.state.currentPage,
        });

        const singleData = await this.companyStore.getCompanyDataById(
          setdiscountData
        );

        await this.setState({ loadList: 1 });

        await this.setState({
          comp_value: singleData,
          companyId: setdiscountData,
        });
      }
      await this.setState({ listDataUpdate: false });
    }
  }

  onEdit = async (record) => {
    await this.context.viewStateStore.setDiscountStates({
      companyId: record.companyId,
    });
    await this.setState({ discountId: record.discountId });
    await this.setState({ openDiscountForm: true });
  };

  async onDelete(record) {
    const response = await this.discountStore.deleteRecord({
      discountId: record.discountId,
    });

    if (response?.data?.success === "S") {
      message.success(response.data.message);
      this.setState({ openDeleteModal: false });
      this.handleSearch();
    } else {
      message.error(response.data.message);
    }
  }

  async handleSearch() {
    this.setState({ loading: true });
    if (this.state.companyId) {
      await this.discountStore.loadData({
        companyId: this.state.companyId,
        offset: (this.state.currentPage - 1) * this.state.pageSize,
        limit: this.state.pageSize,
        page: this.state.currentPage,
      });
    }
    await this.setState({ loadData: 1, loading: false });
  }

  async handleTableChange(pagination, filters, sorter) {
    console.log(pagination);
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    await this.handleSearch();
  }

  async handleChange(comp) {
    await this.setState({
      companyId: comp.value,
      currentPage: 1,
      pageSize: 50,
    });
    const singleData = await this.companyStore.getCompanyDataById(comp.value);
    console.log(singleData);

    await this.setState({ comp_value: singleData });

    await this.handleSearch();
    await this.setState({ loadList: 1 });
  }

  closeModal = () => {
    this.setState({ openDiscountForm: false });
  };

  responseMsg = async (resp) => {
    if (resp.success === "S") {
      message.success(resp.message);
      await this.setState({ listDataUpdate: true });
      await this.setState({ openDiscountForm: false });
      await this.handleSearch();
    }
  };

  refreshList = async () => {
    this.setState({ loading: true });
    if (this.state.companyId) {
      await this.discountStore.loadData({
        companyId: this.state.companyId,
        offset: 0,
        limit: 50,
      });
    }
    this.setState({ loading: false, currentPage: 1 });
  };

  handleClear = async () => {
    await this.setState({ comp_value: null, companyId: "" });
  };
  render() {
    return (
      <>
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={16}>
              <Space>
                <CompanyAutocomplete
                  allowClear={true}
                  onClear={this.handleClear}
                  className="searchInput"
                  onChange={this.handleChange}
                  value={this.state.comp_value ? this.state.comp_value : null}
                  style={{ width: 200 }}
                />
              </Space>
            </Col>

            <Col
              span={8}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <Tooltip
                title={this.context.translate("_REFRESH_")}
                placement="bottom"
              >
                <Image
                  style={{
                    height: 18,
                    alignItems: "center",
                    cursor: "pointer",
                    marginInlineEnd: "20px",
                  }}
                  src={refreshIcon}
                  onClick={() => this.refreshList()}
                ></Image>
              </Tooltip>

              {this.props.canCreate("discountList") && (
                <Button
                  className="addButtonClass"
                  onClick={() =>
                    this.setState({ openDiscountForm: true, discountId: "" })
                  }
                >
                  <Image
                    style={{ marginInlineEnd: "5px", width: 13 }}
                    src={require("../assets/images/NewDesign/plus (Stroke).png")}
                  ></Image>
                  {this.context.translate("_FLEET_ROLE_ROLELIST_ADDBTN_")}
                </Button>
              )}
            </Col>
          </Row>
          <ListTable
            currentPage={this.state.currentPage}
            total={this.discountStore?.total}
            columns={this.columns}
            pageSize={this.state.pageSize}
            dataSource={this.discountStore?.discountList}
            loading={this.discountStore?.loading}
            onChange={this.handleTableChange}
          />
        </div>

        {this.state.openDiscountForm && (
          <Drawer
            className="uploadExcelDrawer"
            // title="Driver Details"
            width={716}
            closeIcon={false}
            placement={
              this.context.locale.language === "arabic" ? "left" : "right"
            }
            footer={false}
            title={
              <div className="formTitle">
                {this.context.translate("_ADD_DISCOUNT_")}
                <p className="formDescription">
                  {this.context.translate("_DISCOUNT_ADD_FORM_DESC_")}
                </p>
              </div>
            }
            bodyStyle={{ height: "645px" }}
            open={this.state.openDiscountForm}
            onCancel={() => {
              this.setState({ openDiscountForm: false, discountId: "" });
            }}
          >
            <div style={{ height: "100%" }}>
              <DiscountAdd
                discountId={this.state.discountId}
                companyId={this.state.companyId}
                response={this.responseMsg}
                closeModal={this.closeModal}
              />
            </div>
          </Drawer>
        )}

        {this.state.openDeleteModal && (
          <Modal
            maskClosable={false}
            title={
              <div className="deleteModalTitle">
                <span>
                  {" "}
                  {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                </span>
                <CloseOutlined
                  style={{ cursor: "pointer", color: "white" }}
                  onClick={() => this.setState({ openDeleteModal: false })}
                />
              </div>
            }
            className="deleteModal"
            description="Are you sure you want to delete this Item? This action cannot be undone."
            centered
            open={this.state.openDeleteModal}
            footer={null}
            width={400}
            closable={false}
          >
            <div className="deleteModalText">
              <p>{this.context.translate("_DELETE_STATUS_")}</p>
            </div>
            <div className="deleteModalButtons">
              <Button
                className="deleteModalCancelButton"
                onClick={() => this.setState({ openDeleteModal: false })}
              >
                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
              </Button>

              <Button
                className="deleteModalOkButton"
                onClick={() => this.onDelete(this.state.deleteData)}
              >
                {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
              </Button>
            </div>
          </Modal>
        )}
      </>
    );
  }
}
DiscountList.contextType = StoreContext;
export default observer(withRouter(DiscountList));
